var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"show":_vm.show}},[_c('div',{staticClass:"p-4"},[_c('AppHeaderBag',{staticClass:"app-mobile-bag",attrs:{"show":_vm.show},on:{"close":function($event){return _vm.$emit('close')}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }